// client/src/lib/api/sales-api.ts
// ===========================================
// MÓDULO DE GESTIÓN DE VENTAS
// Maneja la obtención, creación y listado de productos vendidos.
// Usa apiRequest para inyectar headers y manejar errores de forma tipada.
// ===========================================

import { apiRequest } from "./api-client";

// -------------------------------------------
// Obtener ventas de una tienda
// -------------------------------------------
// COMENTARIO: apiRequest obtiene el JSON completo. Extraemos response.sales
// para mantener la compatibilidad con componentes que esperan directamente el array.
export async function getShopSales(shopId: string): Promise<any[]> {
  const response = await apiRequest<{ sales: any[] }>(
    `/api/shops/${shopId}/sales`,
  );
  return response.sales;
}

// -------------------------------------------
// Obtener productos vendidos por tienda
// -------------------------------------------
export async function getSoldProductsByShop(shopId: string): Promise<any[]> {
  const response = await apiRequest<{ products: any[] }>(
    `/api/shops/${shopId}/sold-products`,
  );
  return response.products;
}

// -------------------------------------------
// Crear una nueva venta
// -------------------------------------------
export async function createSale(saleData: {
  shopId: string;
  total: string;
  items: { productId: string; quantity: number; price: string }[];
}): Promise<any> {
  const response = await apiRequest<{ sale: any }>("/api/sales", {
    method: "POST",
    body: JSON.stringify(saleData),
  });
  return response.sale;
}
